import { z } from 'zod';

export const parkerExportOperatorSchema = z.enum([
	'equals',
	'is',
	'=',
	'!=',
	'not',
	'>',
	'>=',
	'<',
	'<=',
	'after',
	'onOrAfter',
	'before',
	'onOrBefore',
	'isEmpty',
	'isNotEmpty',
	'isAnyOf',
	'contains',
	'startsWith',
	'endsWith',
]);

const filterValueSchema = z.union([
	z.string(),
	z.number(),
	z.boolean(),
	z.array(z.union([z.string(), z.number(), z.boolean()])),
]);

export const parkerExportFilterSchema = z.strictObject({
	propertyName: z.string().trim().min(1),
	op: parkerExportOperatorSchema,
	value: filterValueSchema.optional(),
});

export const parkerExportParametersSchema = z.strictObject({
	filters: z.array(parkerExportFilterSchema).default([]),
	order: z
		.strictObject({
			field: z.string().trim().min(1),
			sort: z.enum(['asc', 'desc']),
		})
		.default({ field: 'lastName', sort: 'asc' }),
	facilityId: z.string().trim().min(1).optional(),
	subscriptionId: z.string().trim().min(1).optional(),
});

export type ParkerExportFilter = z.infer<typeof parkerExportFilterSchema>;
export type ParkerExportParameters = z.infer<typeof parkerExportParametersSchema>;
